import { useEffect, useState } from "react";
import { api, inr, fmtDate } from "./shared";

export const AdminCustomers = ({ onUnauthorized, onSearchOrders }) => {
    const [rows, setRows] = useState(null);
    const [q, setQ] = useState("");
    useEffect(() => {
        api.get("/admin/customers").then((d) => setRows(d.customers)).catch((e) => e.response?.status === 401 && onUnauthorized());
    }, [onUnauthorized]);
    const list = (rows || []).filter((c) => !q || c.name.toLowerCase().includes(q.toLowerCase()) || c.phone.includes(q));
    return (
        <div data-testid="admin-customers">
            <input data-testid="admin-customers-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name or phone…" className="bg-transparent border-b border-charcoal/20 focus:border-gold outline-none py-2 text-sm text-charcoal w-72 mb-6" />
            <div className="border border-gold/25 overflow-x-auto">
                <table className="w-full text-sm" data-testid="admin-customers-table">
                    <thead className="bg-cream/60 text-[10px] tracking-[0.2em] uppercase text-ash"><tr>{["Customer", "Phone", "City", "Orders", "Spent", "Last order", ""].map((h, i) => <th key={i} className="text-left font-normal px-4 py-3">{h}</th>)}</tr></thead>
                    <tbody className="divide-y divide-gold/15">
                        {list.map((c) => (
                            <tr key={c.phone} className="hover:bg-cream/40" data-testid={`customer-row-${c.phone}`}>
                                <td className="px-4 py-3 font-serif text-base text-charcoal">{c.name}</td>
                                <td className="px-4 py-3 text-smoke">{c.phone}</td>
                                <td className="px-4 py-3 text-smoke">{c.city || "—"}</td>
                                <td className="px-4 py-3 text-charcoal">{c.orders}</td>
                                <td className="px-4 py-3 text-charcoal">{inr(c.spent)}</td>
                                <td className="px-4 py-3 text-smoke text-xs">{fmtDate(c.last_order)}</td>
                                <td className="px-4 py-3 text-right"><button onClick={() => onSearchOrders(c.phone)} className="text-[10px] tracking-[0.2em] uppercase text-golddark hover:text-charcoal">View orders</button></td>
                            </tr>
                        ))}
                        {rows && list.length === 0 && <tr><td colSpan={7} className="px-4 py-12 text-center font-serif text-xl text-ash italic">No customers yet</td></tr>}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
